import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { User } from '../models/user';
import { isCyflareAdmin } from './cyflare-admin';

/** Internal-staff-only routes. Stricter than adminRouteGuard, which also admits partner_admin. */
export const cyflareAdminGuard: CanActivateFn = (_route, state) => {
  const router = inject(Router);
  const user = inject(User);

  if (!user.access_token) {
    router.navigate(['/auth/login'], { queryParams: { redirectUrl: state.url } });
    return false;
  }
  if (isCyflareAdmin(user)) {
    return true;
  }
  router.navigate(['customer/unauthorized']);
  return false;
};
